import React from 'react';
import { motion } from 'framer-motion';
export function ValueStack() {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-235">
      <div className="max-w-4xl mx-auto" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A1A1A] mb-12" data-id="element-238">
            📦 Todo lo que recibís hoy
          </h2>

          <div className="bg-orange-50 rounded-lg p-8 mb-8" data-id="element-239">
            <div className="space-y-4 mb-6" data-id="element-240">
              <div className="flex justify-between items-center pb-3 border-b border-gray-300" data-id="element-241">
                <span className="text-gray-700" data-id="element-242">
                  📘 Mamá, Cuéntame Tu Historia
                </span>
                <span className="font-semibold text-gray-700" data-id="element-243">$29.000</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-300" data-id="element-244">
                <span className="text-gray-700" data-id="element-245">
                  🎁 Guía para Acompañar a Mamá
                </span>
                <span className="font-semibold text-gray-700" data-id="element-246">$12.000</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-300" data-id="element-247">
                <span className="text-gray-700" data-id="element-248">
                  💌 Cartas que Mamá Puede Dejar
                </span>
                <span className="font-semibold text-gray-700" data-id="element-249">$15.000</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-300" data-id="element-250">
                <span className="text-gray-700" data-id="element-251">
                  👨‍👩‍👧 Preguntas para la Familia
                </span>
                <span className="font-semibold text-gray-700" data-id="element-252">$10.000</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b-2 border-gray-400" data-id="element-253">
                <span className="text-gray-700" data-id="element-254">
                  🗂️ Plantillas de Fotos y Recuerdos
                </span>
                <span className="font-semibold text-gray-700" data-id="element-255">$15.000</span>
              </div>
              <div className="flex justify-between items-center pt-4" data-id="element-256">
                <span className="text-lg font-bold text-gray-700" data-id="element-257">
                  Valor real total:
                </span>
                <span className="text-lg font-bold text-gray-500 line-through" data-id="element-258">
                  $81.000
                </span>
              </div>
            </div>

            <div className="bg-[#F5A623] text-white rounded-lg p-6 text-center" data-id="element-259">
              <p className="text-xl mb-2" data-id="element-260">🔥 Hoy pagás solo:</p>
              <p className="text-5xl font-bold" data-id="element-261">$19.999</p>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-[#F5A623] text-white py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all mb-8" data-id="element-262">
            💝 QUIERO GUARDAR SU HISTORIA AHORA →
          </motion.button>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-263">
            <div className="text-center" data-id="element-264">
              <div className="text-2xl mb-2" data-id="element-265">🔒</div>
              <p className="text-sm text-gray-700 font-semibold" data-id="element-266">
                Pago 100% seguro
              </p>
            </div>
            <div className="text-center" data-id="element-267">
              <div className="text-2xl mb-2" data-id="element-268">📥</div>
              <p className="text-sm text-gray-700 font-semibold" data-id="element-269">
                Acceso inmediato
              </p>
            </div>
            <div className="text-center" data-id="element-270">
              <div className="text-2xl mb-2" data-id="element-271">↩️</div>
              <p className="text-sm text-gray-700 font-semibold" data-id="element-272">
                Garantía 14 días
              </p>
            </div>
            <div className="text-center" data-id="element-273">
              <div className="text-2xl mb-2" data-id="element-274">♾️</div>
              <p className="text-sm text-gray-700 font-semibold" data-id="element-275">
                Tuyo para siempre
              </p>
            </div>
          </div>

          <div className="bg-red-50 border-2 border-[#D32F2F] rounded-lg p-4 text-center" data-id="element-276">
            <p className="text-[#D32F2F] font-bold" data-id="element-277">
              ⚠️ Oferta por tiempo limitado. Cuando el timer llega a cero, el
              precio vuelve a $81.000.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}